import { render, staticRenderFns } from "./BaseBtnCenterMap.vue?vue&type=template&id=9232646e&scoped=true&lang=pug"
import script from "./BaseBtnCenterMap.vue?vue&type=script&lang=js"
export * from "./BaseBtnCenterMap.vue?vue&type=script&lang=js"
import style0 from "./BaseBtnCenterMap.vue?vue&type=style&index=0&id=9232646e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9232646e",
  null
  
)

export default component.exports